import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'admin/template/industry/socialCategories/templates/<systemTemplateId>';

export function useAdminSocialTemplateImagesQuery({
	enabled = true,
	systemTemplateId,
}: {
	enabled?: boolean;
	systemTemplateId?: string;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!systemTemplateId,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<{ template: Api.ITemplate; statuses: Api.ITemplateStatus[] }>(
				`admin/template/industry/socialCategories/templates/${encodeURIComponent(systemTemplateId)}`,
				'GET'
			),
		queryKey: [BASE_QUERY_KEY, systemTemplateId],
		// A linked post stores its deck's slides as images, exported in slide order.
		select: result =>
			(result?.template?.attachments ?? []).map(attachment => (attachment as Api.IFileAttachmentWithURL).url),
		meta: {
			errorLogging: { fn: 'useAdminSocialTemplateImagesQuery' },
		},
	});
}
